import { useCallback, useRef, useState } from 'react';
import { RoutingRuleType } from 'src/graphql';
import { useRefsByKey } from 'src/hooks';
import { calculateItemJoinerCoordinates } from 'src/utils/reordering/calculateItemJoinerCoordinates';

interface Parameters {
  orderedRules: Omit<RoutingRuleType, 'Author'>[];
  draggingId: string | null;
}

export const useRoutingRuleCoordinates = ({
  orderedRules,
  draggingId,
}: Parameters) => {
  const rulesContainerRef = useRef<HTMLDivElement>(null);
  const { refsByKey, setRef } = useRefsByKey();
  const [ruleJoinerCoordinates, setRuleJoinerCoordinates] = useState<
    (number[] | null[])[]
  >([]);

  const recalculateCoordinates = useCallback(() => {
    if (orderedRules.length) {
      setRuleJoinerCoordinates(
        orderedRules.map((rule, index) =>
          calculateItemJoinerCoordinates({
            item: rule,
            index,
            draggingId,
            orderedList: orderedRules,
            listContainerRef: rulesContainerRef,
            refsByKey,
          }),
        ),
      );
    }
  }, [draggingId, orderedRules, rulesContainerRef, refsByKey]);

  return {
    rulesContainerRef,
    setRef,
    ruleJoinerCoordinates,
    recalculateCoordinates,
  };
};
